import React, { createContext, useContext, useEffect, useState } from 'react';
import { api } from './api.js';
import type { SessionMe } from '@edv-next/contracts';

interface SessCtx {
  me: SessionMe | null;
  orgId: string | null;
  siteId: string | null;
  setOrg(id: string): void;
  setSite(id: string): void;
  reload(): Promise<void>;
}
const Ctx = createContext<SessCtx | null>(null);

export function SessionProvider({ children }: { children: React.ReactNode }) {
  const [me, setMe] = useState<SessionMe | null>(null);
  const [orgId, setOrgId] = useState<string | null>(null);
  const [siteId, setSiteId] = useState<string | null>(null);
  const reload = async () => {
    const r = await api.sessionMe();
    setMe(r as SessionMe);
    if (r.organizations.length && !orgId) setOrgId(r.organizations[0]!.id);
    if (r.sites.length && !siteId) setSiteId(r.sites[0]!.id);
  };
  useEffect(() => {
    reload().catch(() => {});
  }, []);
  return (
    <Ctx.Provider
      value={{
        me,
        orgId,
        siteId,
        setOrg: (id) => {
          setOrgId(id);
          setSiteId(null);
        },
        setSite: setSiteId,
        reload,
      }}
    >
      {children}
    </Ctx.Provider>
  );
}
export function useSession(): SessCtx {
  const v = useContext(Ctx);
  if (!v) throw new Error('SessionProvider missing');
  return v;
}
